/**
 * TCGateB — Terms of Use acceptance gate (bottom-sheet variant).
 *
 * Ported from Yan-Vada Hero Pilot/components/gates.jsx TCGateB.
 * Mobile-first bottom-sheet style. Two-column layout on desktop.
 * Hard gate — cannot proceed without accepting.
 *
 * Fires on first visit to root (before pitch content is visible).
 * Dismissed once accepted; persisted in localStorage via AuthContext.acceptTC().
 */

import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { GateBackdrop, GateCheckbox } from './shared'

export default function TCGate() {
  const { acceptTC } = useAuth()
  const [checked, setChecked] = useState(false)

  const handleAccept = () => {
    if (!checked) return
    acceptTC()
  }

  return (
    <div className="gate-host" style={{ position: 'fixed', inset: 0, zIndex: 9999 }}>
      <GateBackdrop align="bottom" variant="cool">
        <div className="tc-gate-sheet">
          <div className="tc-gate-drag-handle" />

          <div className="tc-gate-grid">
            <div className="tc-gate-copy">
              <span className="legal-eyebrow">Terms of Use</span>
              <h2 className="tc-gate-heading">Quick thing before we continue.</h2>
              <p className="tc-gate-body">
                Don&apos;t redistribute this pitch page. Don&apos;t screenshot the pricing for public posts.
                The full terms live at{' '}
                <a href="/terms" className="tc-gate-link">vada.yan.lk/terms</a>
                {' '}— it&apos;s a two-minute read.
              </p>
            </div>

            <div className="tc-gate-actions">
              <GateCheckbox checked={checked} onChange={setChecked} id="tc-b" label="I accept the Terms of Use." />
              <div className="tc-gate-buttons">
                <button className="btn btn-primary tc-gate-continue"
                  disabled={!checked}
                  onClick={handleAccept}
                >
                  Continue
                </button>
                <a href="/terms" className="btn btn-secondary">Read terms</a>
              </div>
            </div>
          </div>
        </div>
      </GateBackdrop>
    </div>
  )
}
